import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * ProtectedRoute — wraps authenticated routes. Redirects to /welcome
 * while preserving the requested path so the user lands there after
 * authenticating.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-bg text-ink-muted">
        <span className="text-2xs uppercase tracking-[0.2em]">Loading…</span>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/welcome" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}